import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.667 15.667A5.33 5.33 0 0 0 21 10.333 5.33 5.33 0 0 0 15.667 5a5.33 5.33 0 0 0-5.334 5.333 5.33 5.33 0 0 0 5.334 5.334m0 2.666C12.107 18.333 5 20.12 5 23.667v2.666h21.333v-2.666c0-3.547-7.106-5.334-10.666-5.334"
    }, null, -1)
  ])))
}
export default { render: render }